<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div class="pl-12 pr-12 col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <v-col cols="6" class="text-left">
            <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
          </v-col>
          <v-col cols="6" class="v-margit_button text-right">
            <v-btn
              color="#1B437C"
              depressed
              dark
              @click=";(dialogAdd = true), validate('ADD')"
            >
              <v-icon left>mdi-text-box-plus</v-icon>
              เพิ่มของรางวัล
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <!-- ADD -->
          <v-dialog v-model="dialogAdd" persistent max-width="60%">
            <v-card>
              <v-form ref="form_add" v-model="validAdd" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-col class="text-right">
                      <v-btn
                        small
                        color="#E0E0E0"
                        @click=";(dialogAdd = false), clearData()"
                      >
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                    <v-row justify="center">
                      <v-spacer></v-spacer>
                      <v-col cols="10" class="v-margit_text_add">
                        <v-col class="text-center">
                          <v-img
                            class="v_text_add"
                            :src="require('@/assets/Grouptitle.svg')"
                          ></v-img>
                        </v-col>
                        <br />
                        <v-col cols="12">
                          <v-expansion-panels v-model="panel" multiple>
                            <v-expansion-panel>
                              <v-expansion-panel-header
                                >ข้อมูลทั่วไป</v-expansion-panel-header
                              >
                              <v-expansion-panel-content>
                                <br />
                                <v-col cols="12">
                                  <v-img
                                    aspect-ratio="6"
                                    contain
                                    :src="formAdd.pictureUrlPreview"
                                    v-if="formAdd.pictureUrlPreview"
                                  ></v-img>
                                  <!-- <v-avatar size="100px"><img alt="Avatar" :src="formAdd.pictureUrl"></v-avatar> -->
                                  <br />
                                  <v-file-input
                                    required
                                    counter
                                    show-size
                                    :rules="[rules.required]"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera"
                                    label="Image"
                                    @change="selectImg"
                                    v-model="filesAdd"
                                  ></v-file-input>
                                </v-col>
                                <v-row>
                                  <v-col cols="6">
                                    <v-row style="height: 65px">
                                      <v-text-field
                                        v-model="formAdd.name"
                                        label="ชื่อของรางวัล"
                                        placeholder="ชื่อของรางวัล"
                                        outlined
                                        dense
                                        required
                                        :rules="[rules.required]"
                                      ></v-text-field>
                                    </v-row>
                                  </v-col>
                                  <v-col cols="6">
                                    <v-row style="height: 65px">
                                      <v-text-field
                                        v-model="formAdd.subName"
                                        label="ชื่อรองของรางวัล"
                                        placeholder="ชื่อรองของรางวัล"
                                        outlined
                                        dense
                                        required
                                        :rules="[rules.required]"
                                      ></v-text-field>
                                    </v-row>
                                  </v-col>
                                </v-row>
                                <br />
                              </v-expansion-panel-content>
                            </v-expansion-panel>

                            <v-expansion-panel>
                              <v-expansion-panel-header
                                >เงื่อนไข</v-expansion-panel-header
                              >
                              <v-expansion-panel-content>
                                <br />
                                <v-row>
                                  <v-col cols="6">
                                    <v-row style="height: 65px">
                                      <v-text-field
                                        v-model="formAdd.point"
                                        label="คะแนนที่ใช้แลก"
                                        dense
                                        outlined
                                        type="number"
                                        min="0"
                                        required
                                        :rules="[rules.required]"
                                        v-bind:options="options2"
                                      ></v-text-field>
                                    </v-row>
                                  </v-col>
                                  <v-col cols="6">
                                    <v-row style="height: 65px">
                                      <v-text-field
                                        v-model="formAdd.resale"
                                        label="คะแนนเต็มก่อนใช้แลก"
                                        dense
                                        outlined
                                        required
                                        type="number"
                                        min="0"
                                      >
                                      </v-text-field>
                                    </v-row>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <v-col cols="6">
                                    <v-row style="height: 65px">
                                      <v-select
                                        :items="dataLevel"
                                        v-model="formAdd.levelId"
                                        label="ระดับของสมาชิกที่แลกได้"
                                        outlined
                                        dense
                                        :rules="[rules.required]"
                                      ></v-select>
                                      <!-- <VuetifyMoney
                                        v-model="formAdd.resale"
                                        label="คะแนนช่วงโปรโมชั่น"
                                        dense
                                        outlined
                                        required
                                        :rules="[rules.required]"
                                        v-bind:options="options2"
                                      /> -->
                                    </v-row>
                                  </v-col>
                                </v-row>
                                <br />
                              </v-expansion-panel-content>
                            </v-expansion-panel>

                            <v-expansion-panel>
                              <v-expansion-panel-header
                                >หมายเหตุ</v-expansion-panel-header
                              >
                              <v-expansion-panel-content>
                                <br />
                                <v-col cols="12">
                                  <v-row>
                                    <v-textarea
                                      auto-grow
                                      rows="2"
                                      name="input-7-4"
                                      placeholder="รายละเอียด"
                                      label="รายละเอียด"
                                      counter
                                      dense
                                      outlined
                                      required
                                      :rules="[rules.required]"
                                      v-model="formAdd.description"
                                    ></v-textarea>
                                  </v-row>
                                </v-col>
                                <v-col>
                                  <v-row>
                                    <v-radio-group v-model="formAdd.supply" row>
                                      <v-radio
                                        label="รับหน้าร้าน"
                                        value="รับหน้าร้าน"
                                      ></v-radio>
                                      <v-radio
                                        label="จัดส่ง"
                                        value="จัดส่ง"
                                      ></v-radio>
                                      <v-radio
                                        label="link / code"
                                        value="link_code"
                                      ></v-radio>
                                      <v-radio
                                        label="บริจาค"
                                        value="บริจาค"
                                      ></v-radio>
                                    </v-radio-group>
                                  </v-row>
                                </v-col>
                                <v-col>
                                  <v-row no-gutters>
                                    <v-col cols="5">
                                      <v-checkbox
                                        false-value="False"
                                        true-value="True"
                                        v-model="formAdd.trending"
                                        label="รางวัลยอดฮิตในสัปดาห์นี้"
                                      ></v-checkbox>
                                    </v-col>
                                    <!-- <v-col cols="4">
                                      <v-checkbox
                                        false-value="False"
                                        true-value="True"
                                        v-model="formAdd.most"
                                        label="รางวัลสุดฮิต"
                                      ></v-checkbox>
                                    </v-col> -->
                                    <v-col cols="3">
                                      <v-checkbox
                                        false-value="False"
                                        true-value="True"
                                        v-model="formAdd.specialOffer"
                                        label="รางวัลสุดพิเศษ"
                                      ></v-checkbox>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </v-col>

                        <v-col id="margin">
                          <v-row justify="center" style="height: 80px">
                            <v-btn
                              elevation="2"
                              x-large
                              dark
                              color="#173053"
                              :disabled="!validAdd"
                              :loading="loadingAdd"
                              @click="addData()"
                            >
                              <v-icon left>mdi-checkbox-marked-circle</v-icon>
                              เพิ่ม
                            </v-btn>
                          </v-row>
                        </v-col>
                      </v-col>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
            </v-card>
          </v-dialog>
          <!-- end add -->

          <!-- edit -->
          <v-dialog v-model="dialogEdit" persistent max-width="60%">
            <v-card>
              <v-form ref="form_update" v-model="validUpdate" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-col class="text-right">
                      <v-btn
                        small
                        color="#E0E0E0"
                        @click=";(dialogEdit = false), clearData()"
                      >
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                    <v-row justify="center">
                      <v-spacer></v-spacer>
                      <v-col cols="10" class="v-margit_text_add">
                        <v-col class="text-center">
                          <v-img
                            class="v_text_edit"
                            :src="require('@/assets/GroupEditTitle.svg')"
                          ></v-img>
                        </v-col>
                        <br /><br />
                        <v-col cols="12">
                          <v-expansion-panels v-model="panel" multiple>
                            <v-expansion-panel>
                              <v-expansion-panel-header
                                >ข้อมูลทั่วไป</v-expansion-panel-header
                              >
                              <v-expansion-panel-content>
                                <br />
                                <v-row justify="center">
                                  <v-col cols="12" class="text-center">
                                    <v-img
                                      aspect-ratio="6"
                                      contain
                                      :src="formUpdate.pictureUrlPreview"
                                    ></v-img>
                                    <!-- <v-avatar size="100px"><img alt="Avatar" :src="formAdd.pictureUrl"></v-avatar> -->
                                    <br />
                                    <v-file-input
                                      required
                                      counter
                                      show-size
                                      :rules="[rules.resizeImag]"
                                      accept="image/png, image/jpeg, image/bmp"
                                      prepend-icon="mdi-camera"
                                      label="Image"
                                      @change="selectImgUpdate"
                                      v-model="filesUpdate"
                                    ></v-file-input>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <v-col cols="6">
                                    <v-row style="height: 65px">
                                      <v-text-field
                                        v-model="formUpdate.name"
                                        label="ชื่อของรางวัล"
                                        placeholder="ชื่อของรางวัล"
                                        outlined
                                        dense
                                        required
                                        :rules="[rules.required]"
                                      ></v-text-field>
                                    </v-row>
                                  </v-col>
                                  <v-col cols="6">
                                    <v-row style="height: 65px">
                                      <v-text-field
                                        v-model="formUpdate.subName"
                                        label="ชื่อรองของรางวัล"
                                        placeholder="ชื่อรองของรางวัล"
                                        outlined
                                        dense
                                        required
                                        :rules="[rules.required]"
                                      ></v-text-field>
                                    </v-row>
                                  </v-col>
                                </v-row>
                                <br />
                              </v-expansion-panel-content>
                            </v-expansion-panel>

                            <v-expansion-panel>
                              <v-expansion-panel-header
                                >เงื่อนไข</v-expansion-panel-header
                              >
                              <v-expansion-panel-content>
                                <br />
                                <v-row>
                                  <v-col cols="6">
                                    <v-row style="height: 65px">
                                      <v-text-field
                                        v-model="formUpdate.point"
                                        label="คะแนนที่ใช้แลก"
                                        dense
                                        outlined
                                        required
                                        type="number"
                                        min="0"
                                        :rules="[rules.required]"
                                        v-bind:options="options2"
                                      ></v-text-field>
                                    </v-row>
                                  </v-col>
                                  <v-col cols="6">
                                    <v-row style="height: 65px">
                                      <v-text-field
                                        v-model="formUpdate.resale"
                                        label="คะแนนเต็มก่อนใช้แลก"
                                        dense
                                        outlined
                                        type="number"
                                        min="0"
                                      >
                                      </v-text-field>
                                    </v-row>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <v-col cols="6">
                                    <v-row style="height: 65px">
                                      <v-select
                                        :items="dataLevel"
                                        v-model="formUpdate.levelId"
                                        label="ระดับของสมาชิกที่แลกได้"
                                        outlined
                                        dense
                                        :rules="[rules.required]"
                                      ></v-select>
                                      <!-- <VuetifyMoney
                                        v-model="formUpdate.resale"
                                        label="คะแนนช่วงโปรโมชั่น"
                                        dense
                                        outlined
                                        required
                                        v-bind:options="options2"
                                      /> -->
                                    </v-row>
                                  </v-col>
                                </v-row>
                                <br />
                              </v-expansion-panel-content>
                            </v-expansion-panel>

                            <v-expansion-panel>
                              <v-expansion-panel-header
                                >หมายเหตุ</v-expansion-panel-header
                              >
                              <v-expansion-panel-content>
                                <br />
                                <v-col cols="12">
                                  <v-row>
                                    <v-textarea
                                      auto-grow
                                      rows="2"
                                      name="input-7-4"
                                      placeholder="รายละเอียด"
                                      label="รายละเอียด"
                                      counter
                                      dense
                                      outlined
                                      required
                                      :rules="[rules.required]"
                                      v-model="formUpdate.description"
                                    ></v-textarea>
                                  </v-row>
                                </v-col>
                                <v-col>
                                  <v-row>
                                    <v-radio-group
                                      v-model="formUpdate.supply"
                                      row
                                    >
                                      <v-radio
                                        label="รับหน้าร้าน"
                                        value="รับหน้าร้าน"
                                      ></v-radio>
                                      <v-radio
                                        label="จัดส่ง"
                                        value="จัดส่ง"
                                      ></v-radio>
                                      <v-radio
                                        label="link / code"
                                        value="link_code"
                                      ></v-radio>
                                    </v-radio-group>
                                  </v-row>
                                </v-col>
                                <v-col>
                                  <v-row no-gutters>
                                    <v-col cols="5">
                                      <v-checkbox
                                        false-value="False"
                                        true-value="True"
                                        v-model="formUpdate.trending"
                                        label="รางวัลยอดฮิตในสัปดาห์นี้"
                                      ></v-checkbox>
                                    </v-col>
                                    <!-- <v-col cols="4">
                                      <v-checkbox
                                        false-value="False"
                                        true-value="True"
                                        v-model="formUpdate.most"
                                        label="รางวัลสุดฮิต"
                                      ></v-checkbox>
                                    </v-col> -->
                                    <v-col cols="3">
                                      <v-checkbox
                                        false-value="False"
                                        true-value="True"
                                        v-model="formUpdate.specialOffer"
                                        label="รางวัลสุดพิเศษ"
                                      ></v-checkbox>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </v-col>
                        <v-col>
                          <v-row justify="center">
                            <v-btn
                              elevation="2"
                              x-large
                              color="#173053"
                              :disabled="!validUpdate"
                              :loading="loadingEdit"
                              @click="editData()"
                            >
                              <v-icon left>mdi-checkbox-marked-circle</v-icon>
                              บันทึก
                            </v-btn>
                          </v-row>
                        </v-col>
                      </v-col>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
            </v-card>
          </v-dialog>
          <!-- end -->

          <!-- delete -->
          <v-dialog v-model="dialogDelete" persistent max-width="60%">
            <v-card>
              <v-card-title>
                <span class="headline">ลบข้อมูลนี้</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        label="รหัส Reward*"
                        v-model="formUpdate.rewardId"
                        readonly
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  class="btn-color"
                  x-large
                  @click="dialogDelete = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  color="red darken-1"
                  x-large
                  @click="deleteData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  ลบ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end delete -->

          <v-dialog v-model="dialogImport" persistent max-width="60%">
            <v-card>
              <v-card-title>
                <span class="headline">เพิ่มจำนวนของรางวัล</span>
              </v-card-title>
              <v-form ref="form_import" v-model="validImport" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col>
                        <v-text-field
                          v-model="formImport.count"
                          label="จำนวนของรางวัล"
                          outlined
                          dense
                          required
                          :rules="[rules.required]"
                        ></v-text-field>
                      </v-col>
                      <v-col>
                        <v-select
                          v-model="formImport.expireType"
                          :items="typeExpire"
                          label="ประเภทวันหมดอายุ"
                          dense
                          required
                          :rules="[rules.required]"
                          outlined
                          @change="resetType()"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row v-if="formImport.expireType == 'Redeem'">
                      <v-col cols="6">
                        <v-text-field
                          v-model="formImport.countExpire"
                          label="จำนวนวัน"
                          outlined
                          dense
                          required
                          :rules="[rules.required]"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row v-if="formImport.expireType == 'FixDate'">
                      <v-col>
                        <v-menu
                          v-model="menu1"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="formImport.startDate"
                              label="วันที่เริ่มใช้งาน"
                              outlined
                              dense
                              v-bind="attrs"
                              v-on="on"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="formImport.startDate"
                            @input="
                              ;(menu1 = false),
                                (formImport.endDate = formImport.startDate)
                            "
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              dense
                              color="primary"
                              @click="
                                ;(formImport.startDate = new Date()
                                  .toISOString()
                                  .substr(0, 10)),
                                  (formImport.endDate = formImport.startDate),
                                  (menu1 = false)
                              "
                            >
                              วันที่ปัจจุบัน
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col>
                        <v-menu
                          v-model="menu2"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="formImport.endDate"
                              label="วันหมดอายุ"
                              outlined
                              dense
                              v-bind="attrs"
                              v-on="on"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            :min="formImport.startDate"
                            v-model="formImport.endDate"
                            @input="menu2 = false"
                          >
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    elevation="2"
                    class="btn-color"
                    @click=";(dialogImport = false), clearCreateCode()"
                  >
                    <!-- <v-icon left> mdi-cancel</v-icon> -->
                    ปิด
                  </v-btn>
                  <v-btn
                    elevation="2"
                    color="success"
                    :loading="loading"
                    :disabled="!validImport"
                    @click="createCode()"
                  >
                    <!-- <v-icon left>mdi-checkbox-marked-circle</v-icon> -->
                    สร้าง Code
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogView" persistent max-width="60%">
            <v-card>
              <v-card-title>
                <span class="headline">จำนวนของรางวัล</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row justify="center">
                    <v-col cols="12" class="text-center">
                      <v-data-table
                        :headers="columnsView"
                        :items="dataItemView"
                        :items-per-page="10"
                      >
                        <template v-slot:[`item.startDate`]="{ item }">
                          {{ format_dateNotime(item.startDate) }}
                        </template>
                        <template v-slot:[`item.endDate`]="{ item }">
                          {{ format_dateNotime(item.endDate) }}
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  class="btn-color"
                  @click="dialogView = false"
                >
                  <!-- <v-icon left> mdi-cancel</v-icon> -->
                  ปิด
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogImportExcel" persistent max-width="60%">
            <v-card>
              <v-card-title>
                <span class="headline">เพิ่มจำนวนของรางวัล</span>
              </v-card-title>
              <v-form
                ref="form_importExcel"
                v-model="validImportExcel"
                lazy-validation
              >
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <input
                          type="file"
                          @change="importData"
                          accept=".xls,.xlsx"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-btn class="btn-color">
                          <v-icon left>mdi-download</v-icon>
                          <download-excel
                            class="btn btn-default"
                            :data="export_datas"
                            :fields="export_fields"
                            :type="exportType"
                            :worksheet="exportWorksheet"
                            :name="exportFileName"
                          >
                            Download Template
                          </download-excel>
                        </v-btn>
                        <br />
                        <p style="color: red mt-3">
                          *หมายเหตุ : กรณีมีรหัสมากกว่า 1 รหัสให้คั้นด้วย "/"
                        </p>
                        <p style="color: red">ตัวอย่าง ABcd/123456</p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6">
                        <v-autocomplete
                          v-model="formImport.expireType"
                          :items="typeExpire"
                          label="ประเภทวันหมดอายุ"
                          dense
                          required
                          :rules="[rules.required]"
                          outlined
                          @change="resetType()"
                        ></v-autocomplete>
                      </v-col>
                      <v-col
                        cols="6"
                        v-if="
                          formImport.expireType == 'Redeem' &&
                            formUpdate.supply != 'link_code'
                        "
                      >
                        <VuetifyMoney
                          v-model="formImport.countExpire"
                          label="จำนวนวัน"
                          outlined
                          dense
                          required
                          :rules="[rules.required]"
                          v-bind:options="options2"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="formImport.expireType == 'FixDate'">
                      <v-col cols="6">
                        <v-menu
                          v-model="menu1"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="formImport.startDate"
                              prepend-icon="mdi-calendar"
                              label="วันที่เริ่มใช้งาน"
                              outlined
                              dense
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="formImport.startDate"
                            @input="
                              ;(menu1 = false),
                                (formImport.endDate = formImport.startDate)
                            "
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              dense
                              color="primary"
                              @click="
                                ;(formImport.startDate = new Date()
                                  .toISOString()
                                  .substr(0, 10)),
                                  (formImport.endDate = formImport.startDate),
                                  (menu1 = false)
                              "
                            >
                              วันที่ปัจจุบัน
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="6">
                        <v-menu
                          v-model="menu2"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="formImport.endDate"
                              prepend-icon="mdi-calendar"
                              label="วันหมดอายุ"
                              outlined
                              dense
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            :min="formImport.startDate"
                            v-model="formImport.endDate"
                            @input="menu2 = false"
                          >
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <template>
                          <v-data-table
                            :headers="columnsImport"
                            :items="dataItemImport"
                            :items-per-page="5"
                            :sort-by="['status']"
                            :sort-desc="[true]"
                          >
                            <template v-slot:[`item.status`]="{ item }">
                              <v-chip
                                color="red"
                                outlined
                                v-if="item.status === 'False'"
                                >False</v-chip
                              >
                              <v-chip
                                color="green"
                                outlined
                                v-if="item.status === 'True'"
                                >True</v-chip
                              >
                            </template>
                          </v-data-table>
                        </template>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    elevation="2"
                    class="btn-color"
                    @click="
                      ;(dialogImportExcel = false),
                        (dataItemImport = []),
                        clearCreateCode()
                    "
                  >
                    ปิด
                  </v-btn>
                  <template v-if="!dataItemImportChecKHide">
                    <v-btn
                      elevation="2"
                      color="green darken-1"
                      :disabled="!validImportExcel"
                      :loading="loading1"
                      @click="importDataApprove('add')"
                    >
                      นำเข้าใหม่ทั้งหมด
                    </v-btn>
                  </template>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>

          <!-- data table -->
          <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
              <v-card-title>
                <v-text-field
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :search="searchAll2"
                  :items-per-page="10"
                >
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_dateNotime(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ format_dateNotime(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.point`]="{ item }">
                    {{ formatNumber(item.point) }}
                  </template>
                  <!-- <template v-slot:[`item.endDate`]="{ item }">
                    {{ format_date(item.endDate) }}
                  </template> -->
                  <template v-slot:[`item.action`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="btn-color"
                          fab
                          dark
                          x-small
                          v-if="item.quotaCode > 0"
                          @click.stop="
                            ;(dialogView = true), getDataImport(item)
                          "
                        >
                          <v-icon dark>mdi-eye-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>จำนวนของรางวัล</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="btn-color"
                          fab
                          dark
                          x-small
                          @click.stop="getDataById(item, 'edit')"
                        >
                          <v-icon dark> mdi-tools </v-icon>
                        </v-btn>
                      </template>
                      <span>แก้ไขข้อมูล</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          color="red"
                          dark
                          fab
                          x-small
                          @click.stop="getDataById(item, 'delete')"
                        >
                          <v-icon> mdi-delete </v-icon>
                        </v-btn>
                      </template>
                      <span>ลบข้อมูล</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          color="blue"
                          dark
                          fab
                          x-small
                          v-show="item.supply != 'link_code', item.supply != 'บริจาค'"
                          @click.stop="
                            ;(dialogImport = true),
                              validate('Import'),
                              getDataById(item, 'Import')
                          "
                        >
                          <v-icon> mdi-database-import-outline </v-icon>
                        </v-btn>
                      </template>
                      <span>เพิ่มจำนวนของรางวัล</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          color="green"
                          dark
                          fab
                          x-small
                          v-show="item.supply != 'บริจาค'"
                          @click.stop="
                            ;(dialogImportExcel = true),
                              validate('ImportExcel'),
                              getDataById(item, 'ImportExcel')
                          "
                        >
                          <v-icon> mdi-microsoft-excel </v-icon>
                        </v-btn>
                      </template>
                      <span>import excel เพิ่มของรางวัล</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
          <!-- dailog status -->
          <v-dialog v-model="dialogStatus" width="500">
            <v-card>
              <v-card-title class="text-h5 grey lighten-2">
                บันทึกสำเร็จ
              </v-card-title>
              <br />
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" class="text-center">
                    <v-alert dense outlined type="success"
                      >เพิ่มข้อมูลสำเร็จ : {{ formStatus.sucess }}</v-alert
                    >
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" class="text-center">
                    <v-alert dense outlined type="error"
                      >เพิ่มข้อมูลไม่สำเร็จ : {{ formStatus.fail }}</v-alert
                    >
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" class="text-center">
                    <v-data-table
                      :headers="columnsStatus"
                      :items="formStatus.dataStatus"
                      :items-per-page="10"
                      :sort-by="['status']"
                      :sort-desc="[true]"
                    >
                      <template v-slot:[`item.status`]="{ item }">
                        <v-chip
                          color="red"
                          outlined
                          v-if="item.status === 'False'"
                          >False</v-chip
                        >
                        <v-chip
                          color="green"
                          outlined
                          v-if="item.status === 'True'"
                          >True</v-chip
                        >
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="dialogStatus = false">
                  OK
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import VuetifyMoney from '../VuetifyMoney.vue'
import adminLeftMenu from '../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    VuetifyMoney,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile
  },
  created () {
    // setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      PK: '',
      path: '/reward/', // Path Model
      returnLink: '/Master/Reward',
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'ของรางวัล',
          disabled: false,
          href: '/Master/Reward'
        }
      ],
      options2: {
        locale: 'en-US',
        prefix: '',
        suffix: '',
        length: 9,
        precision: 0
      },
      // End Menu Config
      dataReady: true,
      dataReadyView: true,
      canvas: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      code: 'AGE_', // Generate Code
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      dialogStatus: false,
      dialogImportExcel: false,
      dialogView: false,
      // END Dialog Config ADD EDIT DELETE
      session: this.$session.getAll(),
      // Search All
      searchAll: '',
      searchAll2: '',
      filesAdd: null,
      filesUpdate: null,
      // Search Advanced
      search: {
        masAgeCode: '',
        masAgeName: '',
        create_date_start: '',
        create_date_end: '',
        last_date_start: '',
        last_date_end: ''
      },
      formStatus: {
        fail: 0,
        sucess: 0,
        dataStatus: []
      },
      formImport: {
        prefix: '',
        rewardCode: '',
        count: 0,
        CREATE_USER: '',
        LAST_USER: '',
        shopId: this.$session.getAll().data.shopId,
        rewardId: '',
        startDate: new Date().toISOString().substr(0, 10),
        endDate: new Date().toISOString().substr(0, 10),
        expireType: '',
        countExpire: 0,
        genType: '',
        redeemStatus: ''
      },
      formAdd: {
        name: '',
        subName: '',
        point: 0,
        quota: 0,
        description: '',
        CREATE_USER: '',
        LAST_USER: '',
        pictureUrl: '',
        pictureUrlPreview: '',
        trending: 'False',
        most: 'False',
        specialOffer: 'False',
        shopId: this.$session.getAll().data.shopId,
        levelNm: '',
        levelId: '',
        supply: 'รับหน้าร้าน',
        resale: 0
      },
      formUpdate: {
        rewardId: '',
        name: '',
        subName: '',
        point: 0,
        quota: 0,
        description: '',
        // startDate: new Date().toISOString().substr(0, 10),
        // endDate: new Date().toISOString().substr(0, 10),
        LAST_USER: '',
        pictureUrl: '',
        pictureUrlPreview: '',
        trending: 'False',
        most: 'False',
        specialOffer: 'False',
        shopId: '',
        levelNm: '',
        levelId: 'allLevel',
        resale: 0
      },
      dataItemImportChecKHide: true,
      rules: {
        numberRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: value => value.length <= 10 || 'Max 10 characters',
        IDcardRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: value => !!value || 'กรุณากรอก.',
        resizeImag: value =>
          !value ||
          value.size < 2000000 ||
          'Avatar size should be less than 2 MB!',
        counterIDcard: value => value.length <= 13 || 'Max 13 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      // End Form Config ADD EDIT
      // Data Table Config
      typeExpire: [
        { text: 'Fix Date', value: 'FixDate' },
        { text: 'Redeem', value: 'Redeem' }
      ],
      columnsStatus: [
        { text: 'Reward Code', value: 'rewardCode' },
        { text: 'Status', value: 'status', sortable: false }
      ],
      columnsView: [
        { text: 'Reward Code', value: 'rewardCode' },
        { text: 'Expire Type', value: 'expireType' },
        { text: 'สถานะ', value: 'redeemStatus' },
        { text: 'จำนวนวันหมดอายุ', value: 'countExpire' },
        { text: 'วันที่เริ่ม', value: 'startDate' },
        { text: 'วันที่สิ้นสุด', value: 'endDate' }
      ],
      columnsImport: [
        { text: 'Reward Code', value: 'rewardCode' },
        { text: 'Status', value: 'status', sortable: false }
      ],
      columns: [
        { text: 'ID', value: 'rewardId', align: 'left' },
        { text: 'ชื่อ', value: 'name', align: 'left' },
        { text: 'คะแนน', value: 'point', align: 'right' },
        { text: 'คะแนนช่วงโปรโมชั่น', value: 'resale', align: 'right' },
        { text: 'โควต้า', value: 'quotaCode', align: 'right' },
        { text: 'ระดับ', value: 'levelNm', align: 'left' },
        { text: 'คำอธิบาย', value: 'description', align: 'left' },
        { text: 'ประเถทจัดส่ง', value: 'supply', align: 'left' },
        { text: 'วันที่สร้าง', value: 'CREATE_DATE', align: 'center' },
        { text: 'วันที่อัพเดท', value: 'LAST_DATE', align: 'center' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ],
      dataItemImport: [],
      dataItem: [],
      dataItemView: [],
      validAdd: true,
      validUpdate: true,
      validImport: true,
      validImportExcel: true,
      dataLevel: [],
      panel: [0, 1, 2],
      exportType: 'xls',
      exportFileName: 'Template.xls',
      exportWorksheet: 'WorkSheet',
      export_fields: {
        rewardCode: 'rewardCode'
      },
      export_datas: [
        {
          rewardCode: 'กรอก Code'
        }
      ],
      loadingAdd: false,
      loadingEdit: false,
      loading: false,
      loading1: false
      // End Data Table Config
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    // this.getGetToken(this.DNS_IP)
    this.dataReady = false
    // Get Data
    await this.getDataLevel(
      this.DNS_IP,
      this.session.data.shopId,
      this.returnLink
    )
    await this.getDataReward()
  },
  methods: {
    chkSupply () {
      axios
        .get(this.DNS_IP + '/reward/getID?rewardId=' + this.item.rewardId)
        .then(response => {
          let rs = response.data
          console.log('555', rs)
        })
    },
    async getDataLevel (DNS_IP, shopId, returnLink) {
      // Clear Data ทุกครั้ง
      this.dataLevel = []

      await axios
        .get(
          // eslint-disable-next-line quotes
          DNS_IP + '/level/get?shopId=' + shopId,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          // var dateObj = new Date(response.data.CREATE_DATE)
          // var momentObj = moment(dateObj)
          // response.data.CREATE_DATE = momentObj.format('YYYY-MM-DD')
          console.log('getDataLevel', response.data)
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            d.text = d.name
            d.value = d.levelId
            this.dataLevel.push(d)
          }
          this.dataLevel.push({
            text: 'All Level',
            value: 'allLevel',
            levelId: 'allLevel'
          })
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + returnLink)
          // this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
          this.dataReady = true
        })
    },
    async importData (event) {
      this.dataItemImport = []
      var input = event.target
      var reader = new FileReader()
      reader.onload = () => {
        var fileData = reader.result
        var wb = XLSX.read(fileData, { type: 'binary' })
        wb.SheetNames.forEach(async sheetName => {
          var rowObj = XLSX.utils.sheet_to_json(wb.Sheets[sheetName])
          console.log(rowObj)
          // this.dataItemImport = rowObj
          for (var i = 0; i < rowObj.length; i++) {
            var d = rowObj[i]
            await axios
              .get(
                // eslint-disable-next-line quotes
                this.DNS_IP +
                  '/rewardCode/' +
                  'get?rewardId=' +
                  this.formUpdate.rewardId +
                  '&rewardCode=' +
                  d.rewardCode,
                {
                  headers: {
                    'Application-Key': this.$session.getAll().ApplicationKey
                  }
                }
              )
              .then(async response => {
                console.log('data', response)
                if (response.data.status === false) {
                  rowObj
                    .map(e => {
                      return e.rewardCode
                    })
                    .indexOf(d.rewardCode) === i
                    ? (d.status = 'True')
                    : (d.status = 'False')
                } else {
                  d.status = 'False'
                }
              })
            this.dataItemImport.push(d)
          }
          console.log('this.dataItemImport : ', this.dataItemImport)
          if (this.dataItemImport.length === 0) {
            alert('โปรดใส่ไฟล์ให้ถูกต้อง')
          } else {
            this.dataItemImportChecKHide = false
          }
        })
      }

      reader.readAsBinaryString(input.files[0])
    },
    resetType () {
      if (this.formImport.expireType === 'FixDate') {
        this.formImport.startDate = ''
        this.formImport.endDate = ''
      } else {
        this.formImport.countExpire = 0
      }
    },
    async getDataImport (dt) {
      this.dataReadyView = false
      this.dataItemView = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/rewardCode/' + 'get?rewardId=' + dt.rewardId
        )
        .then(async response => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            // if (d.expireType === 'Redeem') {
            //   d.startDate = ''
            //   d.endDate = ''
            // }
            this.dataItemView.push(d)
          }
        })
      this.dataReadyView = true
    },
    async getDataReward () {
      //   const name = 'Hi my name is Flavio'
      //   const nameCleaned = name.replace(/\s/g, '')
      //   console.log('name', nameCleaned)
      // Clear Data ทุกครั้ง
      this.dataItem = []
      // Clear ข้อมูลใน Import
      this.dataItemImport = []
      // Clear ช่องค้นหา
      //   this.searchAll = ''

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + 'get?shopId=' + this.session.data.shopId
        )
        .then(async response => {
          console.log('getData', response.data)
          let rs = response.data
          this.dataItem = rs
          this.dataReady = true
          // this.dataItem = response.data
          this.export_data = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          // this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
          this.dataReady = true
        })
    },
    selectImgUpdate (event) {
      if (this.filesUpdate) {
        this.formUpdate.pictureUrlPreview = URL.createObjectURL(
          this.filesUpdate
        )
      } else {
        this.formUpdate.pictureUrlPreview = ''
      }
      // console.log(event)
    },
    selectImg (event) {
      if (this.filesAdd) {
        this.formAdd.pictureUrlPreview = URL.createObjectURL(this.filesAdd)
      } else {
        this.formAdd.pictureUrlPreview = ''
      }
      // console.log(event)
    },
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break
        case 'Import':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_import.validate()
          })
          break
        case 'ImportExcel':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_importExcel.validate()
          })
          break

        default:
          break
      }
    },
    async searchDataAll () {
      //
      //
      // สำหรับ ค้นหาแบบ LIKE Search
      // ต้องระบุ Field ที่จะส่งไปให้ตรงกับ Model
      //
      var search =
        '?rewardId=' +
        this.searchAll +
        '&name=' +
        this.searchAll +
        '&Point=' +
        this.searchAll +
        '&priviledge=' +
        this.searchAll
      this.dataReady = false
      this.searchDataAllGlobal(this.DNS_IP, this.path, search, this.returnLink)
    },
    async getDataById (item, type) {
      //
      //
      // สำหรับ เรียกข้อมูล ใส่ form Update / Delete
      //
      //
      // Get ID /main.js
      this.dataReady = false
      await this.getDataByIdGlobal(
        this.DNS_IP,
        this.path,
        'rewardId',
        item.rewardId,
        this.returnLink
      )
      this.formUpdate.startDate = moment(
        String(this.formUpdate.startDate)
      ).format('YYYY-MM-DD')
      this.formUpdate.endDate = moment(String(this.formUpdate.endDate)).format(
        'YYYY-MM-DD'
      )
      this.formUpdate.pictureUrlPreview = this.formUpdate.pictureUrl
      if (
        this.formUpdate.levelId !== 'allLevel' &&
        this.formUpdate.levelId !== ''
      ) {
        this.formUpdate.levelId = parseInt(this.formUpdate.levelId)
      }
      if (type === 'edit') {
        this.dialogEdit = true
        this.validate('UPDATE')
      } else if (type === 'delete') {
        this.dialogDelete = true
      }
    },
    createCode () {
      this.$swal({
        title: 'ต้องการ สร้าง Code ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.loading = true
          this.formImport.genType = 'gen'
          this.formImport.CREATE_USER = this.session.data.userName
          this.formImport.LAST_USER = this.session.data.userName
          this.formImport.rewardId = this.formUpdate.rewardId
          this.formImport.redeemStatus = 'open'
          if (this.formImport.expireType === 'Redeem') {
            this.formImport.startDate = ''
            this.formImport.endDate = ''
          }
          this.formImport.prefix = Date.now()
            .toString()
            .substr(10, 12)
          await axios
            .post(this.DNS_IP + '/rewardCode/' + 'add', this.formImport)
            .then(async response => {
              console.log(this.formImport)
              // sucess = sucess + 1
              this.formStatus.fail = response.data.fail
              this.formStatus.sucess = response.data.sucess
              this.formStatus.dataStatus = response.data.dataStatus
              this.loading = false
              this.dialogStatus = true
            })
            .catch(error => {
              console.log('error function addDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
              this.dataReady = true
            })
          // Close Dialog
          this.dialogImport = false

          // Load Data
          await this.clearDataImport()
          this.filesAdd = null
          await this.getDataReward(
            this.DNS_IP,
            this.path,
            this.session.data.shopId,
            this.returnLink
          )
        })
        .catch(error => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async addData () {
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.loadingAdd = true
          var levelId = this.formAdd.levelId
          var dataCheckLevel = this.dataLevel.filter(function (el) {
            return el.value === levelId
          })
          this.formAdd.levelNm = dataCheckLevel[0].text
          this.formAdd.CREATE_USER = this.session.data.userName
          this.formAdd.LAST_USER = this.session.data.userName
          if (this.formAdd.resale === '') {
            this.formAdd.resale = 0
          }
          const _this = this
          let params = new FormData()
          params.append('file', this.filesAdd)

          await axios
            .post(this.DNS_IP + `/file/upload/reward`, params)
            .then(function (response) {
              _this.formAdd.pictureUrl = response.data
              console.log('url Pic', response.data)
            })
          delete this.formAdd['pictureUrlPreview']
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + 'add',
              this.formAdd
              //   {
              //     headers: {
              //       'Application-Key': this.$session.getAll().ApplicationKey
              //     }
              //   }
            )
            .then(async response => {
              // Debug response
              console.log('addDataGlobal DNS_IP + PATH + "add"', response)

              this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogAdd = false

              // Load Data
              await this.clearData()
              this.filesAdd = null
              await this.getDataReward(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
              this.loadingAdd = false
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              console.log('error function addDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
              this.dataReady = true
            })
        })
        .catch(error => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async editData () {
      // this.editDataGlobal(this.DNS_IP, this.path, this.PK, this.formUpdateItem)
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.loadingEdit = true
          this.formUpdate.LAST_USER = this.session.data.userName
          var levelId = this.formUpdate.levelId
          var dataCheckLevel = this.dataLevel.filter(function (el) {
            return el.value === levelId
          })
          console.log('dataCheckLevel', dataCheckLevel, levelId, this.dataLevel)
          this.formUpdate.levelNm = dataCheckLevel[0].text
          var ID = this.formUpdate.rewardId
          if (this.filesUpdate) {
            const _this = this
            let params = new FormData()
            params.append('file', this.filesUpdate)

            await axios
              .post(this.DNS_IP + `/file/upload/reward`, params)
              .then(function (response) {
                _this.formUpdate.pictureUrl = response.data
                console.log('url Pic', response.data)
              })
          } else {
            this.formUpdate.pictureUrl = this.formUpdate.pictureUrlPreview
          }
          delete this.formUpdate['pictureUrlPreview']
          delete this.formUpdate['rewardId']
          delete this.formUpdate['LAST_DATE']
          delete this.formUpdate['CREATE_DATE']
          delete this.formUpdate['startDate']
          delete this.formUpdate['endDate']
          delete this.formUpdate['quotaCode']
          delete this.formUpdate['title']
          delete this.formUpdate['levelName']
          delete this.formUpdate['levelPoint']
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + 'edit/' + ID,
              this.formUpdate
              // {
              //   headers: {
              //     'Application-Key': this.$session.getAll().ApplicationKey
              //   }
              // }
            )
            .then(async response => {
              // Debug response
              console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogEdit = false

              // Load Data
              // await this.reloadData()
              await this.clearDataUpdate()
              this.filesUpdate = null
              await this.getDataReward(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
              this.loadingEdit = false
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
            })
        })
        .catch(error => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async deleteData () {
      this.formUpdate.LAST_USER = this.session.data.userName
      console.log('DELETE PK : ', this.formUpdate.rewardId)
      //
      //
      // สำหรับ ลบข้อมูล
      // ต้องระบุ  Last User ว่าใครเป็นคนลบล่าสุด
      //
      // this.formUpdate.LAST_USER = this.$session.getAll().data.userName
      this.dataReady = false
      await this.deleteDataSubmit(
        this.DNS_IP,
        this.path,
        this.formUpdate.rewardId,
        this.session.data.shopId,
        '',
        this.returnLink
      )
    },
    async deleteDataSubmit (DNS_IP, PATH, ID, shopId, status, returnLink) {
      this.$swal({
        title: 'ต้องการ ลบข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#fa0202',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          await axios
            .post(
              // eslint-disable-next-line quotes
              DNS_IP + PATH + 'delete/' + ID,
              this.formUpdate,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async response => {
              // Debug response
              console.log('DNS_IP + PATH + "delete/"', response)
              console.log('status', status)

              this.$swal('เรียบร้อย', 'ลบข้อมูลเรียบร้อย', 'success')
              // Close Dialog
              this.dialogDelete = false

              // Load Data
              await this.getDataReward(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              this.dataReady = true
              this.$swal('ผิดพลาด', 'ผิดพลาด -1', 'error')
              console.log('error function deleteDataGlobal : ', error)
              this.$router.push('/system/Errorpage?returnLink=' + returnLink)
            })
        })
        .catch(error => {
          this.dataReady = true
          this.$swal('ผิดพลาด', 'ผิดพลาด -2', 'error')
          console.log('error function deleteDataGlobal : ', error)
        })
    },
    async clearData () {
      this.formAdd.name = ''
      this.formAdd.subName = ''
      this.formAdd.point = 0
      this.formAdd.quota = 0
      this.formAdd.description = ''
      this.formAdd.CREATE_USER = ''
      this.formAdd.LAST_USER = ''
      this.formAdd.pictureUrl = ''
      this.formAdd.pictureUrlPreview = ''
      this.formAdd.trending = 'False'
      this.formAdd.most = 'False'
      this.formAdd.specialOffer = 'False'
      this.formAdd.shopId = this.$session.getAll().data.shopId
      this.formAdd.levelNm = ''
      this.formAdd.levelId = ''
      this.formAdd.supply = 'รับหน้าร้าน'
    },
    async clearDataUpdate () {
      this.formUpdate.rewardId = ''
      this.formUpdate.name = ''
      this.formUpdate.subName = ''
      this.formUpdate.point = 0
      this.formUpdate.quota = 0
      this.formUpdate.description = ''
      this.formUpdate.LAST_USER = ''
      this.formUpdate.pictureUrl = ''
      this.formUpdate.pictureUrlPreview = ''
      this.formUpdate.trending = 'False'
      this.formUpdate.most = 'False'
      this.formUpdate.specialOffer = 'False'
      this.formUpdate.shopId = ''
      this.formUpdate.levelNm = ''
      this.formUpdate.levelId = 'allLevel'
    },
    async clearDataImport () {
      this.formImport.prefix = ''
      this.formImport.rewardCode = ''
      this.formImport.count = 0
      this.formImport.CREATE_USER = ''
      this.formImport.LAST_USER = ''
      this.formImport.shopId = this.$session.getAll().data.shopId
      this.formImport.rewardId = ''
      this.formImport.startDate = new Date().toISOString().substr(0, 10)
      this.formImport.endDate = new Date().toISOString().substr(0, 10)
      this.formImport.expireType = ''
      this.formImport.countExpire = 0
      this.formImport.genType = ''
      this.formImport.redeemStatus = ''
    },
    importDataApprove (action) {
      console.log('Action', action)
      var titleMsg = ''
      var checkError = false
      if (action === 'add') {
        titleMsg = 'ท่านต้องการ นำเข้าข้อมูลจากไฟล์นี้ ใช่หรือไม่'
      }

      this.$swal({
        title: titleMsg,
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.loading1 = true
          this.formStatus.dataStatus = []
          this.formStatus.fail = 0
          this.formStatus.sucess = 0
          for (var key in this.dataItemImport) {
            this.PK = this.dataItemImport[key].masBranchID
            if (action === 'add') {
              console.log('add')
              await this.importDataAdd(this.dataItemImport[key])
              checkError = true
            }
          }
          console.log(checkError)
          if (checkError === true) {
            await this.getDataReward(
              this.DNS_IP,
              this.path,
              this.session.data.shopId,
              this.returnLink
            )
            this.clearDataImport()
            // this.$swal('เรียบร้อย', 'เพิ่มข้อมูลสำเร็จ', 'success')
            this.dialogStatus = true
            this.dialogImportExcel = false
          } else {
            this.dataItemImport = []
            this.dataItemImportChecKHide = true
            // alert('โปรดใส่ไฟล์ให้ถูกต้อง')
          }
          this.loading1 = false
        })
        .catch(error => {
          console.log('error function importDataApprove : ', error)
          this.dataReady = true
        })
    },
    async importDataAdd (dt) {
      // Object.assign(this.formAdd, dt)
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/rewardCode/' +
            'get?rewardId=' +
            this.formUpdate.rewardId +
            '&rewardCode=' +
            dt.rewardCode,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          console.log('data', response)
          if (response.data.status === false) {
            this.formImport.genType = 'excel'
            console.log(
              'this.formImport.rewardCode',
              this.formImport.rewardCode
            )
            if (this.formImport.rewardCode.includes('/') === true) {
              //   alert('w')
              this.formImport.rewardCode = dt.rewardCode.replace(/\s/g, '')
            } else if (this.formImport.rewardCode.includes('/') === false) {
              this.formImport.rewardCode = dt.rewardCode

              console.log(this.formImport.rewardCode)
            }
            // this.formImport.rewardCode = dt.rewardCode.replace(/\s/g, "");
            this.formImport.CREATE_USER = this.$session.getAll().data.userName
            this.formImport.LAST_USER = this.$session.getAll().data.userName
            this.formImport.rewardId = this.formUpdate.rewardId
            this.formImport.redeemStatus = 'open'
            if (this.formImport.expireType === 'Redeem') {
              this.formImport.startDate = ''
              this.formImport.endDate = ''
            } else if (this.formImport.expireType === 'FixDate') {
              this.formImport.countExpire = 0
            }
            console.log('this.formImport', this.formImport)
            await axios
              .post(
                // eslint-disable-next-line quotes
                this.DNS_IP + '/rewardCode/' + 'add',
                this.formImport,
                {
                  headers: {
                    'Application-Key': this.$session.getAll().ApplicationKey
                  }
                }
              )
              .then(async response => {
                this.dialogImport = false
                // Debug response
                this.formStatus.sucess = this.formStatus.sucess + 1
                console.log('/rewardCode/add/', response)
                this.formStatus.dataStatus.push({
                  rewardCode: dt.rewardCode,
                  status: 'True'
                })
              })
              // eslint-disable-next-line handle-callback-err
              .catch(error => {
                // alert('โปรดใส่ไฟล์ให้ถูกต้อง', dt)
                console.log('error function importDataAdd addData : ', error)
                this.dataReady = true
              })
          } else {
            this.formStatus.fail = this.formStatus.fail + 1
            this.formStatus.dataStatus.push({
              rewardCode: dt.rewardCode,
              status: 'False'
            })
          }
        })
    },
    clearCreateCode () {
      this.formImport.prefix = ''
      this.formImport.count = ''
      this.formImport.expireType = ''
      this.formImport.countExpire = ''
      this.formImport.startDate = ''
      this.formImport.endDate = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Master/Reward.vue